import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Privacy Policy" lastUpdated="1st Jan 2026">
      <p>
        We value your privacy. This Privacy Policy explains how we collect,
        use, and protect your information.
      </p>

      <section>
        <h2 className="text-xl font-bold text-slate-900">1. Information We Collect</h2>
        <p className="mt-2">We may collect the following data:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>WhatsApp phone number</li>
          <li>Reminder content (e.g., task name and scheduled time)</li>
          <li>Message timestamps and basic usage logs</li>
        </ul>

        <p className="mt-4">We do not collect:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>Payment information</li>
          <li>Sensitive personal data</li>
          <li>Contacts or media from your device</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">2. How We Use Your Data</h2>
        <p className="mt-2">Your data is used solely to:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>Create and manage reminders</li>
          <li>Deliver reminder messages via WhatsApp</li>
          <li>Improve the reliability of the service</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">3. Data Storage and Security</h2>
        <p className="mt-2">
          We take reasonable measures to protect your data from unauthorized
          access, loss, or misuse. Data is stored only as long as necessary to
          provide the service.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">4. Data Sharing</h2>
        <p className="mt-2">
          We do not sell, rent, or trade your personal data.
        </p>
        <p className="mt-2">
          Data may only be shared if required by law or legal process.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">5. Third-Party Services</h2>
        <p className="mt-2">
          This service relies on WhatsApp and related infrastructure. Your use
          of the service is also subject to WhatsApp’s terms and privacy
          policies.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">6. Your Rights</h2>
        <p className="mt-2">You have the right to:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>Access your data</li>
          <li>Request correction or deletion of your data</li>
          <li>Stop using the service at any time</li>
        </ul>
        <p className="mt-4">For data-related requests, contact:</p>
        <p className="mt-2">
          <a
            href="mailto:prakharpandedevwork@gmail.com"
            className="text-blue-600 hover:text-blue-700 font-semibold"
          >
            prakharpandedevwork@gmail.com
          </a>
        </p>
      </section>
    </LegalPageLayout>
  );
}


